import { Form } from 'react-bootstrap';
import styled from "styled-components";

export const Root = styled.div`
	.custom-audio audio {
		margin-top: 60px;
	}

	.mgT60{
		margin-top: 60px;
	}

	.alta-text{
		font-size: 12px;
		border: 1px solid #000;
		border-radius: 4px;
		padding: 0px 6px;
		position: absolute;
		top: 9px;
		font-weight: 700;
		height: 21px;
	}
`;

export const FormContainer = styled(Form)`
	background-image: url(/images/slider-background.png);
	justify-content: center;
	flex-direction: column;
	align-items: center;
	display: flex;
	min-height: 450px;

	.form-control {
		width: 540px;
	}

	.btn[type="submit"] {
		border-radius: 50%;
		height: 82px;
		width: 82px;
	}

	textarea {
		resize: none;
	}

	@media (max-width: 490px){
		justify-content: center;
		flex-direction: row;
		align-items: center;
		display: flex;

		.form-control {
			width: 100%;
		}
	}
`;

export const FormContent = styled.div`
	max-width: 750px;
	display: flex;
	width: 650px;
	gap: 20px;
`;

export const FormContentColumn = styled.div`
	justify-content: ${props => props.alignItems || 'initial'};
	align-items: ${props => props.alignItems || 'initial'};
	flex-direction: column;
	display: flex;
`;

export const DropdownGroupContainer = styled(Form.Group)`
	flex-direction: row;
	display: flex;
	gap: 10px;

	.dropdown-toggle, .dropdown-menu.show {
		min-width: 170px !important;
	}

	.dropdown-toggle {
		justify-content: space-between;
		display: flex;
	}
`;


export const HowItWorks = styled.div`
	padding-bottom: 60px;
	padding-top: 60px;

	h1 {
		margin-top: 17px;
		max-width: 660px;
		font-size: 24px;
		color: #861497;
	}

	h6 {
		margin-top: 25px;
		color: #777;
		font-weight: 400;
		margin-bottom: 30px;
	}

	h5 {
		text-align: center;
		margin-top: 20px;
		color: #000000;
		font-size: 18px;
		margin-bottom: 23px;
	}

	h4 {
		font-size: 20px;
		margin-top: 24px;
	}

	th {
		padding-top: 25px;
	}

	p {
		padding-right: 65px;
		color: #777;
		font-weight: 400;
	}

	h3 {
		color: #861797;
	}

	h3 span {
		color: #000;
	}

	.robot {
		max-width: 340px;
		display: block;
		width: 100%;
		margin-top: 30px;
		margin-left: auto;
		margin-right: auto;
	}

	@media (max-width: 490px){
		audio {
			width: 215px;
		}
		th {
			padding-top: 25px;
			padding-left: 0px;
		}
	}

	@media (max-width: 992px){
		audio {
			width: 230px;
		}
		
		th {
			padding-top: 25px;
			padding-left: 0px;
			min-width: 105px;
		}
	}
`;

export const Concurrency = styled.div`
	.logo-concorrente {
		margin-bottom: 40px;
		height: 80px;
	}

	.input {
		width: 100%;
		margin-top: 40px;
		border: 1px solid #ddd;
		height: 55px;
		border-radius: 40px;
		padding-left: 30px;
		padding-right: 25px;
	}

	h3 {
		text-align: center;
		font-size: 22px;
		padding: 15px 0 35px;
	}

	input {
		width: 100%;
		border-radius: 50px;
		height: 56px;
		background: #f9f9f9;
		border: 1px solid #ddd;
		padding: 0px 25px;
		margin-bottom: 40px;
		font-size: 14px;
	}

	.amazon-polly {
		width: 60px;
		margin-left: auto;
		margin-right: auto;
		display: block;
	}

	.google-cloud {
		width: 60px;
		margin-left: auto;
		margin-right: auto;
		display: block;
	}

	.logo-blackbolt {
		height: 60px;
		margin-left: auto;
		margin-right: auto;
		display: block;
	}

	p{
		text-align: center;
		font-weight: 600;
	}

	.speak {
		background: #f9f9f9;
		padding-top: 20px;
		padding-bottom: 10px;
		border-radius: 10px;
		margin: 5px;
	}

	.speak button {
		position: absolute;
		right: 16px;
		height: 55px;
		width: 55px;
		border-radius: 45px;
		border: 0px;
		cursor: pointer;
	}


	.speak button img {
		width: 19px;
		margin-left: 6px;
		margin-top: -4px;
		box-shadow: 0 0 1em rgba(162, 162, 162, 0.09);
	}

	.speak p{
		margin-bottom: 8px;
		font-weight: 600;
		font-size: 15px;
	}

	.speak audio{
		width: 100%;
		max-width: 260px;
		margin-left: auto;
		margin-right: auto;
		display: block;
		margin-bottom: 45px;
	}

	.custom-th {
		min-width: 215px;
	}

	.table audio {
		width: 270px;
	}

	.table p {
		font-size: 15px;
	}

`;

export const WhoWeAre = styled.div`
	padding: 70px 0px;
	background: #f1f1f1;
	margin-top: 60px;

		.logo-mutant {
			width: 190px;
		}

		h1{
			font-size: 18px;
			margin-top: 15px;
			margin-bottom: 20px;
		}

		h1 span{
			color: #18c0c7;
		}

		p{
			color: #909090;
		}

		a{
			display: inline-block;
			border: 0px;
			padding: 15px 38px;
			border-radius: 100px;
			margin-top: 15px;
			background: #fff;
			color: #18c0c7;
			font-weight: 500;
			box-shadow: 0 0 1em rgba(45, 45, 45, 0.14);
		}

		a:hover{
			text-decoration: none;
		}
`;

export const CustomFooter = styled.div`
	background: #000;
	color: #fff;
	padding-top: 60px;

	ul {
		list-style: none;
		padding-inline-start: 0px !important;
		width: 130px;
		display: block;
		margin-left: auto;
		margin-right: auto;
		margin-top: 30px;
	}

	ul li{
		display: flex;
		align-items: center;
		justify-content: center;
	}

	ul li img{
		width: 15px;
		color: #fff;
	}

	ul li {
		display: inline-block;
		background: #861497;
		width: 44px;
		height: 44px;
		border-radius: 40px;
		margin: 0px 8px;
		padding-left: 14px;
		line-height: 35px;
	}

	.logo-white {
		width: 157px;
		margin-left: auto;
		margin-right: auto;
		display: block;
	}

	h6 {
		text-align: center;
		margin-top: 15px;
		font-size: 18px;
	}

	hr {
		margin-top: 35px;
		margin-bottom: 0;
		border-color: #444;
	}

	p {
		margin: 25px 0px;
		font-size: 12px;
	}

	.text-right {
		text-align: right;
	}

`;

export const PageWrapper = styled.div`
  background-image: url(/images/slider-background.png);
  background-size: cover;
  background-position: center;
  padding: 50px 0;
`;

export const PlayerWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;